// Amateur Topic 11 — Fair Value Gap. Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Fair Value Gap',
  summary: 'Holes left by fast candles that price often comes back to fill.',
  subtopics: [
    { title: 'What It Is', scene: 'fvgWhat', cards: [
      { icon: '🕳️', title: 'A hole in price', body: 'A Fair Value Gap (FVG) is an empty space left when price moves very fast.' },
      { icon: '3️⃣', title: 'Three candles', body: 'Look at 3 candles. If the wick of candle 1 and the wick of candle 3 do not touch, the space between is the gap.' },
      { icon: '⚖️', title: 'Imbalance', body: 'Too many buyers (or sellers) at once. Few trades happened in the gap, so it is "unfair".' },
      { icon: '🧲', title: 'Price likes to return', body: 'Price often comes back to fill the gap before moving on.' },
    ] },
    { title: 'Identifying It', scene: 'fvgIdent', cards: [
      { icon: '🔍', title: 'Find a big candle', body: 'Start with one big, fast candle.' },
      { icon: '🟢', title: 'Bullish FVG', body: 'Gap between candle 1 HIGH and candle 3 LOW.' },
      { icon: '🔴', title: 'Bearish FVG', body: 'Gap between candle 1 LOW and candle 3 HIGH.' },
      { icon: '📦', title: 'Draw a box', body: 'Mark the gap with a box and extend it to the right.' },
    ] },
    { title: 'Trading Into the Zone', scene: 'fvgTrade', cards: [
      { icon: '⏳', title: 'Wait for the return', body: 'Let price come back into the gap.' },
      { icon: '🕯️', title: 'Confirm by close', body: 'Wait for a candle in your direction to close inside or at the gap.' },
      { icon: '🛑', title: 'Stop beyond the gap', body: 'For a bullish FVG, stop below the gap. For bearish, above it.' },
      { icon: '🟡', title: 'Gold example', body: 'Bullish FVG at 2,380–2,405. Gold dips to 2,390, a green candle closes, buy with a stop below 2,360.' },
    ] },
    { title: "When It's Considered Filled", scene: 'fvgFilled', cards: [
      { icon: '🌗', title: 'Partly filled', body: 'Price touches part of the gap and bounces. Many traders count this as used.' },
      { icon: '🌕', title: 'Fully filled', body: 'Price trades through the whole gap. The hole is closed.' },
      { icon: '❌', title: 'Closed beyond it', body: 'If a candle body closes past the far side, the FVG is no longer valid.' },
      { icon: '🔭', title: 'Bigger is better', body: 'FVGs on H1–D1 matter more than tiny M1 gaps.' },
    ] },
  ],
};
